/**
 * Éléments de configuration partagés par plusieurs pages/composantes dans la section '/client'
 */

const getAvailableAssistiveDevicesI18nKeys = (): string[] => [
  'pages.modifyAssistiveDevicesView.availableDevices.bequille',
  'pages.modifyAssistiveDevicesView.availableDevices.canne',
  'pages.modifyAssistiveDevicesView.availableDevices.canneBlanche',
  'pages.modifyAssistiveDevicesView.availableDevices.chienGuide',
  'pages.modifyAssistiveDevicesView.availableDevices.fauteuilMotorise',
  'pages.modifyAssistiveDevicesView.availableDevices.fauteuilManuelNonPliable',
  'pages.modifyAssistiveDevicesView.availableDevices.fauteuilManuelPliable',
  'pages.modifyAssistiveDevicesView.availableDevices.fauteuilQuadriporteur',
  'pages.modifyAssistiveDevicesView.availableDevices.fauteuilTriporteur',
  'pages.modifyAssistiveDevicesView.availableDevices.deambulateur',
  'pages.modifyAssistiveDevicesView.availableDevices.marchetteNonPliable',
  'pages.modifyAssistiveDevicesView.availableDevices.marchettePliable',
  'pages.modifyAssistiveDevicesView.availableDevices.oxygene',
];

export {
  getAvailableAssistiveDevicesI18nKeys,
};
